import React, { useEffect } from "react"
import { Field, FormSection, initialize, reduxForm } from "redux-form"
import { FORM_NAMES } from "constants/index"
import { Card, CardBody, Row, Col, CardHeader } from "reactstrap"
import { connect } from "react-redux"
import {
  getCalendarEventFeature,
  getCalendarEvents,
  resetCalendarEventFeature,
  updateCalendarEvents,
} from "store/actions"
import { CheckboxGroup } from "components/RenderInput"
import { SaveButton } from "components/Buttons"
import validate from "./calendarEventsValidation"
import PropTypes from "prop-types"
import Preview from "./preview"
import { LoadingIndicator } from "components/LoadingIndicator"

let CalendarEvents = props => {
  useEffect(() => {
    if (!props?.selectedEvent?.business_unit_id) {
      props.getCalendarEvents({ type: 1 })
    } else {
      props.getCalendarEvents({
        business_unit_id: props?.selectedEvent?.business_unit_id,
        type: 1,
      })
    }
    props.getCalendarEventFeature({ menu_item_id: props.feature.id })
    return () => {
      props.resetCalendarEventFeature()
    }
  }, [])

  useEffect(() => {
    if (props.calendarEventFeature?.calendar_ids) {
      props.initializeForm(props.calendarEventFeature?.calendar_ids)
    }
  }, [props.calendarEventFeature])

  const handleSubmit = data => {
    props.updateCalendarEvents({
      calendar_ids: data?.calendar_events_form.calendarEvents,
      event_id: props?.selectedEvent ? props?.selectedEvent?.id : null,
      menu_item_id: props.feature.id,
      vendor_id: props.vendorId,
    })
  }

  return (
    <FormSection name={props.form}>
      {props?.loading ? (
        <LoadingIndicator />
      ) : (
        <Card>
          <CardBody className="shadow-sm">
            <Row className="mb-3">
              <h3>{props.feature.label}</h3>
            </Row>
            <Row>
              <Col>
                <Card>
                  <CardHeader>
                    <h4>SELECT CALENDAR(S)</h4>
                  </CardHeader>
                  <CardBody>
                    <Row className="my-3">
                      <Col xl={12}>
                        <h5>Calendars:</h5>
                      </Col>
                      <Col xl={12}>
                        <Field
                          name="calendarEvents"
                          component={CheckboxGroup}
                          options={props.calendarEvents.map(calendar => ({
                            value: calendar.id,
                            label: calendar.name,
                          }))}
                        />
                      </Col>
                    </Row>
                  </CardBody>
                </Card>
                <Row className="my-2">
                  <Col className="d-flex justify-content-center">
                    <SaveButton
                      content="Save"
                      type="button"
                      onClick={props.handleSubmit(handleSubmit)}
                    />
                  </Col>
                </Row>
              </Col>
              <Col xl={4} className="mt-4 custom-features-preview">
                <Preview
                  menu_bg_color={props.design?.menu_bg_color}
                  menu_font_color={props.design?.menu_font_color}
                  label={props.feature?.label}
                />
              </Col>
            </Row>
          </CardBody>
        </Card>
      )}
    </FormSection>
  )
}

CalendarEvents = reduxForm({
  form: FORM_NAMES.CALENDAR_EVENTS,
  validate,
})(CalendarEvents)

const mapStateToProps = state => ({
  selectedEvent: state.experiences.selectedEvent,
  vendorId: state.Login.vendorId,
  calendarEvents: state.CalendarEvents.calendarEvents,
  calendarEventFeature: state.CalendarEvents.calendarEventFeature,
  loading: state.CalendarEvents.loading,
})

const mapDispatchToProps = dispatch => ({
  initializeForm: values =>
    dispatch(
      initialize(FORM_NAMES.CALENDAR_EVENTS, {
        calendar_events_form: { calendarEvents: values },
      })
    ),
  getCalendarEvents: values => dispatch(getCalendarEvents(values)),
  updateCalendarEvents: values => dispatch(updateCalendarEvents(values)),
  resetCalendarEventFeature: () => dispatch(resetCalendarEventFeature()),
  getCalendarEventFeature: values => dispatch(getCalendarEventFeature(values)),
})

CalendarEvents.propTypes = {
  feature: PropTypes.object,
}

export default connect(mapStateToProps, mapDispatchToProps)(CalendarEvents)
